import NavBar from '../components/NavBar'
import HeroSection from '../components/StaffTrainingOnboarding/HeroSection'
import Footer from '../components/Footer'
import ProcessSection from '../components/StaffTrainingOnboarding/ProcessSection'
import TechStackMarquee from '../components/StaffTrainingOnboarding/TechStackMarquee'
import ContactMap from '../components/ContactMap'

const StaffTrainingOnboarding = () => {
	return (
		<div className="min-h-screen">
			<NavBar />
			<HeroSection />
			<ProcessSection />
			<TechStackMarquee />
			<ContactMap />
			<Footer />
		</div>
	)
}

export default StaffTrainingOnboarding